import { stateProperty, State, StateMap } from "@dodona/lit-state";
import { createStateFromInterface } from "@/state/CreateStateFromInterface";
import { fetch } from "@/utilities";

interface DraftAnswerData {
    id: number;
    draft_answer: string;
    draft_summary: string;
}

export class DraftAnswer extends createStateFromInterface<DraftAnswerData>() {
    @stateProperty id: number;
}

class DraftAnswerState extends State {
    @stateProperty private byId = new StateMap<number, DraftAnswer>();

    private async fetch(id: number): Promise<DraftAnswer> {
        const url = `/draft_answers/${id}.json`;
        const response = await fetch(url);
        const data = await response.json();
        this.byId.set(id, new DraftAnswer(data));
        return this.byId.get(id);
    }

    get(id: number): DraftAnswer {
        if (!this.byId.has(id)) {
            void this.fetch(id);
        }
        return this.byId.get(id);
    }
}

export const draftAnswerState = new DraftAnswerState();
